import multiguard from 'vue-router-multiguard';
import middleware from '@/router/middleware';

import Drainage from '@/views/drainage/DrainageTool';
import Single from '@/views/drainage/Single';

export default {
  path: 'drainage',
  component: Drainage,
  name: 'drainage',
  meta: { title: 'Drainage tool' },
  beforeEnter: multiguard([
    middleware.hasPlan,
    middleware.isNotSuperImpact
  ]),
  children: [
    {
      path: ':id',
      component: Single,
      name: 'drainage-edit',
      meta: {title: 'Drainage'},
    },
  ]
};
